<template>
  <v-main>
    <v-container fluid grid-list-md>
      <v-layout row wrap>
        <v-flex xs12>
          <h1 class="mt-n3">{{$t("scan-code-deliveries")}}</h1>
        </v-flex>

        <v-flex xs12 class="mb-4">
          <v-layout row wrap>
          <v-btn v-if="!ScanCodeDisableButtons" class="ml-1 mr-4 mt-4" :to="{name: 'create-scan-code-scan', params: {id: null, pendingVehicles: pendingVehicles}}" color="primary">
            <v-icon left>add</v-icon>
            {{$t("New")}}
          </v-btn>
          <v-flex grow></v-flex>
          <!-- <v-flex shrink><v-select class="ml-2" hide-details="true" :items="plants" v-model="plantName" @change="plantChanged" :label="$t('Plant')"></v-select></v-flex> -->
          <v-flex shrink><v-select class="ml-2" hide-details="true" :items="facilitiesDisplay" v-model="facilityDisplay" @change="facilityChanged" :label="$t('Facility')"></v-select></v-flex>
          </v-layout>
        </v-flex>

        <v-progress-linear v-if="loading" :indeterminate="true"></v-progress-linear>
        <v-flex xs12 v-else>
          <div v-if="deliveries != null && deliveries.length == 0" class="mt-4" style="text-align: center">{{$t("No unfinished registrations found")}}</div>
          <div v-else v-for="scReg in orderedRegistrations" :key="scReg.id">
            <v-card raised class="mb-4" v-if="scReg.FinishedBy == null && !scReg.Registration.Completed">
              <v-layout row wrap>
                <v-flex xs12 md6>
                  <v-layout v-if="!isHide('Vehicle')" row wrap class="textsize-svs" style="padding: 2px 2px 2px 14px">
                    <v-flex d-flex xs4 class="font-weight-bold">{{$t("Vehicle")}}:</v-flex>
                    <v-flex d-flex xs8 class="font-weight-bold" >{{scReg.Registration.VehicleNo}} - {{scReg.Registration.VehicleLicensePlateNo}}</v-flex>
                  </v-layout>
                  <v-layout v-if="!isHide('Article')" row wrap class="textsize-svs" style="padding: 2px 2px 2px 14px">
                    <v-flex d-flex xs4>{{$t("Article")}}:</v-flex>
                    <v-flex d-flex xs8 style="padding-right: 6px">{{scReg.Registration.ArticleNo}} - {{scReg.Registration.ArticleName}}</v-flex>
                  </v-layout>
                  <v-layout v-if="!isHide('Carrier')" row wrap class="textsize-svs" style="padding: 2px 2px 2px 14px">
                    <v-flex d-flex xs4>{{$t("Carrier")}}:</v-flex>
                    <v-flex d-flex xs8 style="padding-right: 6px">{{scReg.Registration.CarrierNo}} - {{scReg.Registration.CarrierName}}</v-flex>
                  </v-layout>
                  <v-layout v-if="!isHide('Customer')" row wrap class="textsize-svs" style="padding: 2px 2px 2px 14px">
                    <v-flex d-flex xs4>{{$t("Customer")}}:</v-flex>
                    <v-flex d-flex xs8 style="padding-right: 6px">{{getCustomerStr(scReg)}}</v-flex>
                  </v-layout>
                  <v-layout v-if="!isHide('Agreement')" row wrap class="textsize-svs" style="padding: 2px 2px 2px 14px">
                    <v-flex d-flex xs4>{{$t("Agreement")}}:</v-flex>
                    <v-flex d-flex xs8 style="padding-right: 6px">{{scReg.Registration.AgreementNo}} - {{scReg.Registration.AgreementName}}</v-flex>
                  </v-layout>
                  <v-layout v-if="!isHide('Delivery')" row wrap class="textsize-svs" style="padding: 2px 2px 2px 14px">
                    <v-flex d-flex xs4>{{$t("Delivery")}}:</v-flex>
                    <v-flex d-flex xs8 style="padding-right: 6px">{{scReg.Registration.DeliveryNo}} - {{scReg.Registration.DeliveryName}}</v-flex>
                  </v-layout>
                  <v-layout v-if="!isHide('RequisitionNo1')" row wrap class="textsize-svs" style="padding: 2px 2px 2px 14px">
                    <v-flex d-flex xs4>{{$t("RequisitionNo1")}}:</v-flex>
                    <v-flex d-flex xs8>{{scReg.Registration.RequisitionNo1}}</v-flex>
                  </v-layout>
                  <v-layout v-if="!isHide('RequisitionNo2')" row wrap class="textsize-svs" style="padding: 2px 2px 2px 14px">
                    <v-flex d-flex xs4>{{$t("RequisitionNo2")}}:</v-flex>
                    <v-flex d-flex xs8>{{scReg.Registration.RequisitionNo2}}</v-flex>
                  </v-layout>
                  <v-layout v-if="!isHide('Scan')" row wrap class="textsize-svs" style="padding: 2px 2px 2px 14px">
                    <v-flex d-flex xs4>{{$t("Scan")}}:</v-flex>
                    <v-flex d-flex xs8 class="textsize-small" v-html="getScanStr(scReg)"></v-flex>
                  </v-layout>
                </v-flex>
                <v-flex xs12 md6>
                  <v-layout row wrap class="textsize-svs" style="padding: 2px 2px 2px 14px">
                    <v-flex d-flex xs4>{{$t("ScanXRegNo")}}:</v-flex>
                    <v-flex d-flex xs8>{{scReg.Registration.ScanXRegNo}}</v-flex>
                  </v-layout>
                  <v-layout row wrap class="textsize-svs" style="padding: 2px 2px 2px 14px">
                    <v-flex d-flex xs4>{{$t("Weight")}}:</v-flex>
                    <v-flex d-flex xs8>{{getWeightStr(scReg)}}</v-flex>
                  </v-layout>
                  <v-layout row wrap class="textsize-svs" style="padding: 2px 2px 2px 14px">
                    <v-flex d-flex xs4>{{$t("Date")}}:</v-flex>
                    <v-flex d-flex xs8>{{getDate(scReg.Registration.DateFirst)}}</v-flex>
                  </v-layout>
                  <!-- <v-layout row wrap class="textsize-svs" style="padding: 2px 2px 2px 14px">
                    <v-flex d-flex xs4>{{$t("RegistrationNo")}}:</v-flex>
                    <v-flex d-flex xs8>{{scReg.Registration.No}}</v-flex>
                  </v-layout> -->
                  <v-layout v-if="!isHide('Plant')" row wrap class="textsize-svs" style="padding: 2px 2px 2px 14px">
                    <v-flex d-flex xs4>{{$t("Plant")}}:</v-flex>
                    <v-flex d-flex xs8 style="padding-right: 6px">{{scReg.Registration.PlantNo}} - {{scReg.Registration.PlantName}}</v-flex>
                  </v-layout>
                  <v-layout v-if="!isHide('Facility')" row wrap class="textsize-svs" style="padding: 2px 2px 2px 14px">
                    <v-flex d-flex xs4>{{$t("Facility")}}:</v-flex>
                    <v-flex d-flex xs8>{{scReg.Registration.Facility}}</v-flex>
                  </v-layout>
                  <v-layout v-if="!isHide('Comment')" row wrap class="textsize-svs" style="padding: 2px 2px 2px 14px">
                    <v-flex d-flex xs4>{{$t("Comment")}}:</v-flex>
                    <v-flex d-flex xs8>{{scReg.Registration.Comment1}}</v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
              <v-divider></v-divider>
                <v-card-actions style="padding: 0px 0px 0px 0px" v-if="scReg.FinishedBy == null && !scReg.Registration.Completed">
                  <v-flex xs12 text-left>
                   <v-btn class="mr-1 mb-1" @click="cancelRegistration(scReg.Id)" :color="'error'">
                      {{$t("Cancel")}}
                    </v-btn>
                  </v-flex>
                  <v-flex xs12 text-left>
                     <div class="red--text" style="padding: 0px 0px 0px 10px">{{getMessage(scReg)}}</div>
                  </v-flex>
                  <v-flex xs12 text-right>
                    <v-btn :disabled="scReg.ScannedData === '[]' || scReg.Registration.ScanXRegNo === 0" class="mr-1 mb-1" @click="finishRegistration(scReg.Id)" color="success">
                      {{$t("Finish")}}
                    </v-btn>
                    <v-btn v-if="!ScanCodeDisableButtons" class="mr-1 mb-1" :to="{name: 'edit-scan-code-scan', params: {id: scReg.Id, pendingVehicles: []}}" color="primary">
                      {{$t("Edit")}}
                    </v-btn>
                  </v-flex>
              </v-card-actions>
            </v-card>
          </div>

        </v-flex>
      </v-layout>
      <v-layout row wrap>
        <div v-if="loading"></div>
        <v-flex xs12 v-else>
          <h2 class="mb-4 mt-4">{{$t("Recent Registrations")}}</h2>
        </v-flex>

        <div v-if="loading"></div>
        <v-flex xs12 v-else>
          <div v-if="deliveries != null && deliveries.length == 0" class="mt-4" style="text-align: center">{{$t("No recent registrations found")}}</div>
          <div v-else v-for="scReg in orderedRegistrationsReverse" :key="scReg.id">
            <v-card raised class="mb-4" v-if="scReg.FinishedBy != null || scReg.Registration.Completed">
              <v-layout row wrap>
                <v-flex xs12 md6>
                  <v-layout v-if="!isHide('Vehicle')" row wrap class="textsize-svs" style="padding: 2px 2px 2px 14px">
                    <v-flex d-flex xs4 class="font-weight-bold">{{$t("Vehicle")}}:</v-flex>
                    <v-flex d-flex xs8 class="font-weight-bold" >{{scReg.Registration.VehicleNo}} - {{scReg.Registration.VehicleLicensePlateNo}}</v-flex>
                  </v-layout>
                  <v-layout row wrap class="textsize-svs" style="padding: 2px 2px 2px 14px">
                    <v-flex d-flex xs4>{{$t("Article")}}:</v-flex>
                    <v-flex d-flex xs8 style="padding-right: 6px">{{scReg.Registration.ArticleNo}} - {{scReg.Registration.ArticleName}}</v-flex>
                  </v-layout>
                  <v-layout v-if="!isHide('Carrier')" row wrap class="textsize-svs" style="padding: 2px 2px 2px 14px">
                    <v-flex d-flex xs4>{{$t("Carrier")}}:</v-flex>
                    <v-flex d-flex xs8 style="padding-right: 6px">{{scReg.Registration.CarrierNo}} - {{scReg.Registration.CarrierName}}</v-flex>
                  </v-layout>
                  <v-layout v-if="!isHide('Customer')" row wrap class="textsize-svs" style="padding: 2px 2px 2px 14px">
                    <v-flex d-flex xs4>{{$t("Customer")}}:</v-flex>
                    <v-flex d-flex xs8 style="padding-right: 6px">{{getCustomerStr(scReg)}}</v-flex>
                  </v-layout>
                  <v-layout v-if="!isHide('Agreement')" row wrap class="textsize-svs" style="padding: 2px 2px 2px 14px">
                    <v-flex d-flex xs4>{{$t("Agreement")}}:</v-flex>
                    <v-flex d-flex xs8 style="padding-right: 6px">{{scReg.Registration.AgreementNo}} - {{scReg.Registration.AgreementName}}</v-flex>
                  </v-layout>
                  <v-layout v-if="!isHide('Delivery')" row wrap class="textsize-svs" style="padding: 2px 2px 2px 14px">
                    <v-flex d-flex xs4>{{$t("Delivery")}}:</v-flex>
                    <v-flex d-flex xs8 style="padding-right: 6px">{{scReg.Registration.DeliveryNo}} - {{scReg.Registration.DeliveryName}}</v-flex>
                  </v-layout>
                  <v-layout v-if="!isHide('RequisitionNo1')" row wrap class="textsize-svs" style="padding: 2px 2px 2px 14px">
                    <v-flex d-flex xs4>{{$t("RequisitionNo1")}}:</v-flex>
                    <v-flex d-flex xs8>{{scReg.Registration.RequisitionNo1}}</v-flex>
                  </v-layout>
                  <v-layout v-if="!isHide('RequisitionNo2')" row wrap class="textsize-svs" style="padding: 2px 2px 2px 14px">
                    <v-flex d-flex xs4>{{$t("RequisitionNo2")}}:</v-flex>
                    <v-flex d-flex xs8>{{scReg.Registration.RequisitionNo2}}</v-flex>
                  </v-layout>
                  <v-layout v-if="!isHide('Scan')" row wrap class="textsize-small" style="padding: 2px 2px 2px 14px">
                    <v-flex d-flex xs4>{{$t("Scan")}}:</v-flex>
                    <v-flex d-flex xs8 v-html="getScanStr(scReg)"></v-flex>
                  </v-layout>
                </v-flex>
                <v-flex xs12 md6>
                  <v-layout row wrap class="textsize-svs" style="padding: 2px 2px 2px 14px">
                    <v-flex d-flex xs4>{{$t("ScanXRegNo")}}:</v-flex>
                    <v-flex d-flex xs8>{{scReg.Registration.ScanXRegNo}}</v-flex>
                  </v-layout>
                  <v-layout row wrap class="textsize-svs" style="padding: 2px 2px 2px 14px">
                    <v-flex d-flex xs4>{{$t("Weight")}}:</v-flex>
                    <v-flex d-flex xs8>{{getWeightStr(scReg)}}</v-flex>
                  </v-layout>
                  <v-layout row wrap class="textsize-svs" style="padding: 2px 2px 2px 14px">
                    <v-flex d-flex xs4>{{$t("Date")}}:</v-flex>
                    <v-flex d-flex xs8>{{getDate(scReg.Registration.DateFirst)}}</v-flex>
                  </v-layout>
                  <!-- <v-layout row wrap class="textsize-svs" style="padding: 2px 2px 2px 14px">
                    <v-flex d-flex xs4>{{$t("RegistrationNo")}}:</v-flex>
                    <v-flex d-flex xs8>{{scReg.Registration.No}} {{scReg.ParentRegistrationNo == scReg.Registration.No ? '' : ' (' + scReg.ParentRegistrationNo + ')'}}</v-flex>
                  </v-layout> -->
                  <v-layout v-if="!isHide('Plant')" row wrap class="textsize-svs" style="padding: 2px 2px 2px 14px">
                    <v-flex d-flex xs4>{{$t("Plant")}}:</v-flex>
                    <v-flex d-flex xs8 style="padding-right: 6px">{{scReg.Registration.PlantNo}} - {{scReg.Registration.PlantName}}</v-flex>
                  </v-layout>
                  <v-layout v-if="!isHide('Facility')" row wrap class="textsize-svs" style="padding: 2px 2px 2px 14px">
                    <v-flex d-flex xs4>{{$t("Facility")}}:</v-flex>
                    <v-flex d-flex xs8>{{scReg.Registration.Facility}}</v-flex>
                  </v-layout>
                  <v-layout v-if="!isHide('Comment')" row wrap class="textsize-svs" style="padding: 2px 2px 2px 14px">
                    <v-flex d-flex xs4>{{$t("Comment")}}:</v-flex>
                    <v-flex d-flex xs8>{{scReg.Registration.Comment1}}</v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
              <v-divider></v-divider>
                <v-card-actions style="padding: 0px 0px 0px 0px" v-if="scReg.FinishedBy != null || scReg.Registration.Completed">
                  <v-flex xs6>
                    <div class="red--text" style="padding: 0px 0px 0px 10px">{{getMessage(scReg)}}</div>
                  </v-flex>
                  <v-flex xs6 text-right>
                    <v-btn class="mr-1 mb-1" @click="printRegistration(scReg.Id)" color="primary" :disabled="!scReg.Registration.Completed || scReg.Registration.ScanXRegNo == 0">
                      {{$t("Print")}}
                    </v-btn>
                  </v-flex>
              </v-card-actions>
            </v-card>
          </div>

        </v-flex>
      </v-layout>
    </v-container>
  </v-main>
</template>

<script>
import { app } from '@/main'
import filters from '@/core/mixins/common-filters'
import * as DateUtil from '@/core/date'
import * as ScanCode from '@/modules/scan-code/scan-code'
import * as Archive from '@/core/archive'
import * as LocalStorage from '@/core/local-storage'
import * as Security from '@/core/security'
import _ from 'lodash' // clone

export default {
  mixins: [filters],
  name: 'deliveries',
  data () {
    return {
      loading: true,
      deliveries: null,
      loadRegistrationsIntervalId: null,
      facilityNo: null,
      facilities: [],
      facilitiesDescription: [],
      facilityDescription: '',
      useFacilityDescription: false,
      facilityDisplay: '',
      facilitiesDisplay: [],
      plantName: null,
      plants: [],
      ScanCodeDisableButtons: false,
      hiddenFields: [],
      pendingVehicles: [],
      RegistrationType: { Registrations: '0', Deliveries: '1' },
      scReg: {
        id: '00000000-0000-0000-0000-000000000000',
        registrationId: '00000000-0000-0000-0000-000000000000',
        finishedDate: null,
        finishedBy: Security.user.name,
        comment: null,
        TareWeight: 0,
        Registration: null,
        ScannedData: null
      }
    }
  },
  watch: {
  },
  methods: {
    printRegistration (regId) {
      ScanCode.printRegistration(regId)
      this.$root.$message.showSuccess(this.$t('Confirmation printed'))
    },
    getHeaderValue (item, header) {
      let result = ''
      if (!Object.prototype.hasOwnProperty.call(header, 'Source') || (header.Source === 'WeightRegistration' || header.Source == null)) {
        result = item.WeightRegistration[header.Field]
      } else {
        if (header.Source === 'ScanCodeRegistration') {
          result = item[header.Field]
        }
      }
      if (header.AsDate) result = DateUtil.getSmartDate(result)
      return result
    },
    getHeaderStyle (header) {
      let result = ''
      if (Object.prototype.hasOwnProperty.call(header, 'Style')) {
        result = header.Style
      }
      return result
    },
    async plantChanged () {
      if (this.plantName != null) LocalStorage.save('plantName', this.plantName)
      this.deliveries = null
      // Re-Load deliveries
      this.loadScanCodeRegistrations()
    },
    async facilityChanged () {
      if (this.useFacilityDescription) {
        var facilityDisplay = this.facilitiesDisplay.find(f => f.value === this.facilityDisplay)
        if (facilityDisplay != null) {
          this.facilityNo = facilityDisplay.item.No
        }
      } else {
        this.facilityNo = this.facilityDisplay
      }
      if (this.facilityNo != null) LocalStorage.save('facilityNo', this.facilityNo)

      // Re-Load Plants
      const plantsRes = await Archive.loadPlants(this.facilityNo)
      if (!plantsRes.failed) {
        // Let user select no plants (= show data from all allowed plants)
        if (!plantsRes.data.includes('')) plantsRes.data.unshift({ No: '', Name: '' })
        this.plants = plantsRes.data.map(item => {
          return {
            text: item.Name,
            value: item.Name,
            item: item
          }
        })
      }
      // Set this.plantName
      if (this.plants.some(e => e.item.Name === this.plantName)) {
        // this.plantName is OK
      } else {
        this.plantName = null
        LocalStorage.remove('plantName')
      }

      this.deliveries = null
      // Re-Load deliveries
      this.loadScanCodeRegistrations()
    },
    async updateUi () {
    },
    getDate (date) {
      return DateUtil.getSmartDate(date)
    },
    getCustomerStr (scReg) {
      if (scReg.Registration.CustomerNo && scReg.Registration.CustomerName) { return scReg.Registration.CustomerNo + ' - ' + scReg.Registration.CustomerName } else if (scReg.Registration.CustomerNo) { return scReg.Registration.CustomerNo } else if (scReg.Registration.CustomerName) { return scReg.Registration.CustomerName } else { return '' }
    },
    getScanStr (scReg) { // show all regs with linebreaks in a string // if articleNo sort wanted, just use .sort((a, b) => (a.articleNo - b.articleNo))).map(...)
      return JSON.parse(scReg.ScannedData.replaceAll('<', '').replaceAll('>', ' ')).map(s => s.articleNo + ' - ' + s.articleName + ' (' + s.kg + ' kg) [' + s.regNo + ']').toString().replaceAll(',', '  ' + (scReg.ScannedData.length > 2000 ? ' ' : '<br>'))
    },
    getWeightStr (scReg) {
      if (scReg && scReg.CreatedBy.startsWith('corp:')) {
        // Weighing is via weightbridge
        if (scReg.Registration.Completed) {
          return scReg.Registration.WeightNet + ' kg'
        } else {
          return scReg.Registration.WeightFirst + ' kg (' + this.$t('WeightFirst') + ')' // Vehicle has only done a first weighing
        }
      } else {
        // Weighing is via ScanCode
        return Math.abs(scReg.Registration.WeightFirst - scReg.Registration.WeightSecond) + ' kg'
      }
    },
    getMessage (scReg) {
      if (scReg) {
        if (scReg.Registration.Cancelled) {
          return this.$t('Cancelled')
        } else if (!scReg.Registration.Completed) {
          if (!scReg.Registration.DateFirst) {
            return this.$t('No registration')
          } else {
            if (scReg.Registration.ScanXRegNo === 0) {
              return this.$t('Awaiting Weight ID from ScanX.NET')
            }
            return ' '
          }
        } else {
          if (scReg.Registration.ScanXRegNo === 0) {
            return this.$t('Awaiting Weight ID from ScanX.NET')
          }
          return ''
        }
      } else {
        return ''
      }
    },
    isHide (fieldName) {
      return this.hiddenFields.some(h => h === fieldName)
    },
    async loadScanCodeRegistrations () {
      // Re-Load deliveries
      const res = await ScanCode.loadRegistrations({ Facility: this.facilityNo, RegistrationType: this.RegistrationType.Deliveries })
      if (!res.failed) this.deliveries = res.data
      // Filter deliveries on plantName - if any
      if (this.plantName && this.deliveries) this.deliveries = this.deliveries.filter(r => r.Registration.PlantName === this.plantName)
      // Load pending Vehicles for New button parameter
      this.pendingVehicles = this.deliveries.filter(r => r.FinishedBy == null && !r.Registration.Completed).map(p => p.Registration.VehicleNo)
    },
    async cancelRegistration (id) {
    // Grab an update of the reg to get ScanXRegNo etc.
      const res1 = await ScanCode.loadRegistration(id)
      if (!res1.failed) {
        this.scReg.Registration = res1.data.Registration
        this.scReg.id = id
        this.scReg.registrationId = this.scReg.Registration.Id
        this.scReg.facilityNo = this.facilityNo
        this.scReg.comment = this.scReg.Registration.Comment1
        this.scReg.Registration.Cancelled = true
        this.scReg.ScannedData = res1.data.ScannedData
      }
      this.submitting = true
      const res2 = await ScanCode.saveRegistration({
        Id: this.scReg.id,
        RegistrationId: this.scReg.registrationId,
        Facility: this.scReg.facilityNo,
        DeletedDate: new Date(),
        DeletedBy: this.scReg.finishedBy,
        Comment: this.scReg.comment,
        Registration: this.scReg.Registration,
        ScannedData: this.scReg.ScannedData,
        RegistrationType: 1, // 1 = Deliveries
        ParentRegistrationNo: 0
      })
      this.submitting = false
      if (!res2.failed) {
        this.$root.$message.showError(this.$t('Cancelled'))
        // Re-Load registrations
        this.loadScanCodeRegistrations()
      }
    },
    async finishRegistration (id) {
    // Grab an update of the reg to get ScanXRegNo etc.
      const res1 = await ScanCode.loadRegistration(id)
      if (!res1.failed) {
        this.scReg.Registration = res1.data.Registration
        this.scReg.id = id
        this.scReg.facilityNo = this.facilityNo
        this.scReg.registrationId = res1.data.RegistrationId
        this.scReg.finishedDate = res1.data.FinishedDate
        this.scReg.finishedBy = res1.data.FinishedBy
        this.scReg.CreatedBy = res1.data.CreatedBy
        this.scReg.comment = res1.data.Comment
        this.scReg.Registration = res1.data.Registration
        this.scReg.ScannedData = res1.data.ScannedData
      }
      this.submitting = true
      const res2 = await ScanCode.saveRegistration({
        Id: this.scReg.id,
        RegistrationId: this.scReg.registrationId,
        Facility: this.scReg.facilityNo,
        FinishedDate: new Date(),
        FinishedBy: this.scReg.finishedBy,
        Comment: this.scReg.comment,
        Registration: this.scReg.Registration,
        ScannedData: this.scReg.ScannedData,
        RegistrationType: 1, // 1 = Deliveries
        ParentRegistrationNo: 0
      })

      this.submitting = false
      if (!res2.failed) {
        this.$root.$message.showSuccess(this.$t('Registration finished'))
        // Re-Load registrations
        this.loadScanCodeRegistrations()
      }
    },
    async finishRegistration1 () {
      this.confirmDialog = false
      this.preventLeave = false
      this.finishing = true
      const res = await ScanCode.saveRegistration({
        Id: this.wlReg.id,
        RegistrationId: this.wlReg.registrationId,
        Facility: this.form.facilityNo,
        FinishedDate: new Date(),
        FinishedBy: this.wlReg.finishedBy,
        Comment: this.wlReg.comment,
        Registration: this.wlReg.Registration,
        ScannedData: this.wlReg.ScannedData,
        RegistrationType: 1, // 1 = Deliveries
        ParentRegistrationNo: 0
      })
      this.finishing = false
      if (!res.failed) {
        this.$root.$message.showSuccess(this.$t('Registration finished'))
      }
    }

  },
  computed: {
    orderedRegistrations: function () {
      var self = this // Need this to refence this.newestFirst inside compare function.
      var sortComparer = function (a, b) {
        // if a is less than b, return -1
        // if a is greater than b, return 1
        // if a is equal to b, return 0
        var aDate = new Date(a.CreatedDate)
        var bDate = new Date(b.CreatedDate)
        /* if(self.newestFirst)
          return bDate - aDate;
        else */
        return aDate - bDate
      }

      if (self.deliveries) {
        return self.deliveries.sort(sortComparer)
      } else {
        return []
      }
    },
    orderedRegistrationsReverse: function () {
      return this.orderedRegistrations.slice().reverse()
    }
  },
  beforeDestroy () {
    // Stop update of delivery list
    clearInterval(this.loadRegistrationsIntervalId)
  },
  async mounted () {
    var noValue = Security.user.corporationDetails.find(d => d.Name === 'Sys_UseFacilityDescription')?.Data1 === undefined ?? false
    if (noValue) {
      this.useFacilityDescription = false
    } else {
      this.useFacilityDescription = Security.user.corporationDetails.find(d => d.Name === 'Sys_UseFacilityDescription')?.Data1 === 'true' ?? false
    }
    // Update delivery list every 5 seconds
    this.loadRegistrationsIntervalId = setInterval(async () => {
      // Re-Load deliveries
      this.loadScanCodeRegistrations()
    }, 5000)

    // We use next tick to ensure that app is initialized
    this.$nextTick(() => {
      app.$on('force-update', () => {
        // We need this to ensure that autoLogin re-renders component
        this.$forceUpdate()
      })
    })

    // Use Settings from cached user's corporatationDetails
    if (Security.user.corporationDetails) {
      this.ScanCodeDisableButtons = Security.user.corporationDetails.find(d => d.Name === 'ScanCode_Disable_Buttons')?.Data1 === 'true' ?? false
      const defaultHidden = 'RequisitionNo2,Plant,Carrier,Comment' // New fields default hidden LSV/MITH. Remember to also add new defaults in Settings.vue and Registration.vue
      this.hiddenFields = (Security.user.corporationDetails.find(d => d.Name === 'ScanCode_Deliv_Fields_Hidden')?.Data1 ?? defaultHidden).split(',')
    }

    // Load Facilities
    const facilitiesRes = await Archive.loadFacilities()
    const facilitiesResDescription = _.cloneDeep(facilitiesRes)
    if (!facilitiesRes.failed) {
      // Let user select no facilities (= show data from all allowed facilities)
      if (!facilitiesRes.data.includes('')) facilitiesRes.data.unshift({ No: '', Name: '' })
      this.facilities = facilitiesRes.data.map(item => {
        return {
          text: item.No,
          value: item.No,
          item: item
        }
      })
      this.facilitiesDisplay = this.facilities
      if (this.useFacilityDescription) {
      // const facilitiesRes2 = await Archive.loadFacilities()
        var d = facilitiesResDescription.data
        if (!d.includes('')) d.unshift({ No: '', Description: '' })
        this.facilitiesDescription = d.map(item => {
          return {
            text: item.Description,
            value: item.Description,
            item: item
          }
        })

        this.facilitiesDisplay = this.facilitiesDescription
      }
    }
    // Set old this.facilityNo from LocalStorage
    const storedFacilityNo = '' + LocalStorage.load('facilityNo')
    // Set old this.facilityNo from LocalStorage
    if (storedFacilityNo && this.facilities.some(e => e.item.No === storedFacilityNo)) {
      this.facilityNo = storedFacilityNo
      this.facilityDisplay = this.facilityNo
    } else {
      this.facilityNo = null
      LocalStorage.remove('facilityNo')
    }
    if (this.useFacilityDescription) {
      if (this.facilityNo == null) { this.facilityNo = '' }
      this.facilityDisplay = this.facilitiesDescription.find(f => f.item.No === this.facilityNo).value
    } else {
      if (this.facilityNo == null) { this.facilityNo = '' }
      this.facilityDisplay = this.facilities.find(f => f.item.No === this.facilityNo).value
    }
    // Load Plants
    const plantsRes = await Archive.loadPlants(this.facilityNo)
    if (!plantsRes.failed) {
      // Let user select no plants (= show data from all allowed plants)
      if (!plantsRes.data.includes('')) plantsRes.data.unshift({ No: '', Name: '' })
      this.plants = plantsRes.data.map(item => {
        return {
          text: item.Name,
          value: item.Name,
          item: item
        }
      })
    }
    // Set old this.plantName from LocalStorage
    const storedPlantName = LocalStorage.load('plantName')
    if (storedPlantName && this.plants.some(e => e.item.Name === storedPlantName)) this.plantName = storedPlantName
    else {
      this.plantName = null
      LocalStorage.remove('plantName')
    }

    // Load delivery list first time
    this.loadScanCodeRegistrations()
    this.loading = false
  }
}
</script>

<style>

</style>
